import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { useAuth } from "../context/AuthContext";

const AuthOptionsScreen = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { authenticate } = useAuth();

  useEffect(() => {
    document.title = "Authenticate";
  }, []);

  const permitKiss = false; // flip to true to enable kiss flow

  const handleKissPress = () => {
    setLoading(true);
    setError("");
    setSuccess(false);

    setTimeout(() => {
      if (permitKiss) {
        setSuccess(true);
        setTimeout(() => {
          setLoading(false);
          authenticate();
          navigate("/video");
        }, 900);
      } else {
        setLoading(false);
        setError("Error: Kiss not found!");
      }
    }, 2200);
  };

  return (
    <main className="page center-viewport">
      <div className="container" style={{ maxWidth: 720 }}>
        <section className="card auth-card enter-up" aria-labelledby="authTitle">
          <h2 id="authTitle" className="auth-title">⚠️ Uh oh! ⚠️</h2>
          <p className="auth-desc">Looks like the content you're trying to access is <strong style={{ color: "red" }}>locked</strong> 😭</p>
          <p className="auth-desc">Select one of the following forms of authentication:</p>

          {loading ? (
            <div className="spinner-wrapper" role="status" aria-live="polite">
              {success ? (
                <div className="status-msg success" aria-hidden={false}>✓ Success — unlocking…</div>
              ) : (
                <>
                  <div className="spinner-wrapper">
                    <ClipLoader size={36} color={"var(--color-cadet)"} loading={loading} />
                    <div style={{ fontSize: 16, color: "var(--color-muted)" }}>Analyzing Kiss</div>
                  </div>
                </>
              )}
            </div>
          ) : (
            <>
              <div className="auth-actions" role="group" aria-label="Authentication options">
                <button
                  type="button"
                  onClick={handleKissPress}
                  className="btn btn--accent option-btn"
                  aria-pressed="false"
                >
                  <span className="label">Kiss</span>
                  <span aria-hidden> 😘</span>
                </button>

                <button
                  type="button"
                  onClick={() => navigate("/password")}
                  className="btn btn--primary option-btn"
                >
                  <span className="label">Password</span>
                  <span aria-hidden> 🔑</span>
                </button>
              </div>

              {error && <div className="status-msg error" role="alert">{error}</div>}

              <div style={{ marginTop: 18 }}>
                <button type="button" onClick={() => navigate("/")} className="btn btn--danger">Back</button>
              </div>
            </>
          )}
        </section>
      </div>
    </main>
  );
};

export default AuthOptionsScreen;
